import styled, { css } from 'styled-components';

const HelpTooltipWrapper = styled.div` 
  ${(props) => (props.inline ? 'display: inline-block; margin-left: 10px;' : '')}

  .help-icon {
    position: ${(props) => (props.inline ? 'unset' : 'absolute')};
    z-index: 1;
  }

  .help-info {
    margin: 5px;
    position: ${(props) => (props.fixed ? 'fixed' : 'absolute')};
    text-align: center;
    top: ${(props) => (props.fixed ? '50vh' : '10px')};
    max-width: 500px;
    min-width: 100px;
    min-height: 50px;
    height: max-content;
    left: ${(props) => (props.fixed ? '50vw' : 'unset')};
    right: ${(props) => (props.fixed ? 'unset' : '5px')};
    z-index: 1000;
    border-radius: 5px;
    box-shadow: 0px 0px 3px 0px rgba(0, 0, 0, 0.5);
    background-color: white;
    padding: 5px 15px 0 15px;
    transform: ${(props) => (props.fixed ? 'translate(-50%, -50%)' : 'unset')};
    ${(props) => (props.messageStyles ? props.messageStyles : '')}
  }
`;

export default HelpTooltipWrapper;
